export default __webpack_public_path__ + "static/media/chromatography.88201210.jpg";